import { render } from "./Diagnosis1.vue?vue&type=template&id=05acc8dd&scoped=true"
import script from "./Diagnosis1.vue?vue&type=script&lang=js"
export * from "./Diagnosis1.vue?vue&type=script&lang=js"

import "./Diagnosis1.vue?vue&type=style&index=0&id=05acc8dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05acc8dd"],['__file',"src/views/clinic/Diagnosis1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05acc8dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05acc8dd', __exports__)) {
    api.reload('05acc8dd', __exports__)
  }
  
  module.hot.accept("./Diagnosis1.vue?vue&type=template&id=05acc8dd&scoped=true", () => {
    api.rerender('05acc8dd', render)
  })

}


export default __exports__